import * as stu from "./stu";

const Chat = {
    state: {
        userListStu: {
            contactUserList: [],
            groupUserList: [],
            chatroomUserList: [],
        },
        msgListStu: {
            contact: {},
            group: {},
            chatroom: {},
        },
        currentMsgs: [],
        // 当前群聊所有用户
        currentGAllUser: [],
        // 获取群聊未读答疑数
        noReadNums: "",
        // 求职者端获取的HR详情
        hrInfos: {},
        // 表示单聊未读消息
        singleUnreadInfo: [],
        // 表示群聊未读消息
        groupUnreadInfo: [],
        // 表示记录hr答疑数量
        hrQuestionNumRecords: {},
        // 多端同步 1v1通知用
		    noticeCallMsg: {},
        // 表示计算属性强制更新
       computeForceUpdateNum: ""
    },

    mutations: {
        ...stu.mutations,
    },
    actions: {
        ...stu.actions,
    },
    getters: {
        ...stu.getters,
        singleUnreadInfo: state => state.singleUnreadInfo,
        groupUnreadInfo: state => state.groupUnreadInfo
    },
};
export default Chat;



// WEBPACK FOOTER //
// ./src/store/chat.js